/**
 * Attempt to close the current browser tab/window.
 * Browsers only allow closing tabs opened by script; fall back to about:blank.
 */
export function closeBrowserTab(event) {
  if (event?.preventDefault) {
    event.preventDefault();
  }

  window.opener = null;
  window.open('', '_self', '');
  window.close();

  setTimeout(() => {
    try {
      window.location.replace('about:blank');
    } catch {
      // ignore
    }
    window.close();
  }, 50);
}
